import type { ReactNode } from 'react';
import { TONE_BADGE, TONE_DOT, TONE_OUTLINE, type Tone } from './tone';

interface BadgeProps {
  tone?: Tone;
  /** Show a leading status dot (use for statuses; not for counts or tags). */
  dot?: boolean;
  children: ReactNode;
  className?: string;
  title?: string;
  /** `outline` (D-22): hairline + tinted text, no fill. For priority and other tags that are not a status. */
  variant?: 'soft' | 'outline';
}

/** Soft semantic badge (DESIGN_SYSTEM.md §2.3). Text always carries the meaning; colour only supports it. */
export default function Badge({ tone = 'neutral', dot = false, children, className = '', title, variant = 'soft' }: BadgeProps) {
  return (
    <span
      title={title}
      className={`inline-flex min-h-6 items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${variant === 'outline' ? `border bg-transparent ${TONE_OUTLINE[tone]}` : TONE_BADGE[tone]} ${className}`}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${TONE_DOT[tone]}`} aria-hidden="true" />}
      {children}
    </span>
  );
}
